export default {"src":"__ASTRO_ASSET_IMAGE__JcLL9$uL__","width":3500,"height":1450,"format":"webp"}